import styled from "@emotion/styled/macro";
import headerMobile from "../../assets/images/verifHeaderMobile.png";
import header from "../../assets/images/verifHeader.png";
import { BodyContentLayout } from "../../components/ui/ContentLayout";
import CardPart from "../../components/pageParts/CardPart";
import { useTranslation, Trans } from "react-i18next";
import FaqPart from "../Faq/FaqPart";
import PageHeader from "../../components/pageParts/PageHeader";
import { Divider } from "@chakra-ui/react";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background: ${({ theme }) => theme.colors.white};
`;
const WhiteContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 3em 2em;
  }
  display: flex;
  flex-direction: column;
  padding: 0;
  line-height: 1.5em;
`;

const Subtitle = styled.h2`
  border-top: 1px solid ${({ theme }) => theme.colors.opal};
  padding-top: 2em;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0.6em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border: 0;
    padding: 0;
  }
`;

const Subsubtitle = styled.h3`
  padding-top: 2em;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0.4em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border: 0;
  }
`;
const Text = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  color: ${({ theme }) => theme.colors.primary};
`;
const Wrapper = styled.div`
  display: flex;
`;
const Parts = styled.div`
  padding-bottom: 4em;
`;
const Details = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-left: 4em;
    display: flex;
    flex-direction: column;
    width: fit-content;
  }
`;
const NavMenu = styled.div`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 35%;
    flex-direction: column;
    display: flex;
  }
`;
const StyledDivider = styled(Divider)`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    border-color: ${({ theme }) => theme.colors.secondary};
    margin-bottom: 4em;
  }
`;
const MenuItem = styled.li`
  list-style: none;
  cursor: pointer;
  padding-bottom: 1em;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-top: 1em;
    border-bottom: 1px solid ${({ theme }) => theme.colors.opal};
  }
`;

const Verification = () => {
  const { t } = useTranslation();
  const scroll = (scrollTo) => {
    document.querySelector(`#${scrollTo}`)?.scrollIntoView({
      behavior: "smooth",
    });
  };
  const cards = ["insurance", "abroad", "accident"];
  return (
    <Container>
      <PageHeader
        title={t("verification.title")}
        text={t("verification.info")}
        background={header}
        imgMobile={headerMobile}
      />
      <WhiteContainer>
        <BodyContentLayout>
          <Wrapper>
            <NavMenu>
              <ul>
                <MenuItem onClick={() => scroll("intro")}>{t("verification.intro")}</MenuItem>
                <MenuItem onClick={() => scroll("police")}>{t("verification.police")}</MenuItem>
                <MenuItem onClick={() => scroll("otherPartie")}>{t("verification.otherPartie")}</MenuItem>
              </ul>
            </NavMenu>
            <Details>
              <Parts id="intro">
                <Subtitle>{t("verification.intro")}</Subtitle>
                <Text>
                  <Trans i18nKey="verification.introText">
                    vehicle. <br /> <br /> the
                  </Trans>
                </Text>
              </Parts>
              <StyledDivider />
              <Parts id="police">
                <Subtitle>{t("verification.police")}</Subtitle>
                <Text>
                  <Trans i18nKey="verification.policeText">
                    minutes? <br /> in website.
                    <br />
                    <br /> the
                  </Trans>
                </Text>
                <Subsubtitle>{t("verification.statusconfirmedSubtitle")}</Subsubtitle>
                <Text>{t("verification.statusconfirmedText")}</Text>
                <Subsubtitle>{t("verification.statusNotconfirmedSubtitle")}</Subsubtitle>
                <Text>{t("verification.statusNotconfirmedText")}</Text>
              </Parts>
              <StyledDivider />
              <Parts id="otherPartie">
                <Subtitle>{t("verification.otherPartie")}</Subtitle>
                <Text>
                  <Trans i18nKey="verification.otherPartieText">
                    <br />
                  </Trans>
                </Text>
              </Parts>
            </Details>
          </Wrapper>
        </BodyContentLayout>
      </WhiteContainer>
      <CardPart cards={cards} />

      <FaqPart topic={t("header.menu.verification")} />
    </Container>
  );
};

export default Verification;
